'use client';

import { useState } from 'react';
import Link from "next/link";
import { apps } from './sections';
import './main.scss';

import OurServices from "./OurServices"; 


export default function Home() {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState(apps);
  const [isSearching, setIsSearching] = useState(false);

  const handleSearch = () => {
    if (!searchTerm.trim()) {
      setSearchResults(apps);
      setIsSearching(false);
      return;
    }

    setIsSearching(true);
    const term = searchTerm.toLowerCase();
    
    const filteredResults = apps
      .map(section => {
        // Filter items within each section
        const matchingItems = section.items.filter(item => 
          item.name.toLowerCase().includes(term) || 
          item.desc.toLowerCase().includes(term)
        );
        
        // Return section with filtered items if matches found
        if (matchingItems.length > 0) {
          return {
            ...section,
            items: matchingItems
          };
        }
        
        return null;
      })
      .filter((section): section is typeof apps[0] => section !== null); // This is the fix
    
    setSearchResults(filteredResults);
  };

  const handleKeyDown = (e: { key: string; }) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const clearSearch = () => {
    setSearchTerm('');
    setSearchResults(apps);
    setIsSearching(false);
  };

  return (
    <div className="home-container">
      <header className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="gradient-text">Template</span>Hub
          </h1>
          <p className="hero-subtitle">Explore single and multi-page website templates</p>
          <div className="search-bar">
            <input 
              type="text" 
              placeholder="Search templates..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <button className="search-button" onClick={handleSearch}>
              <span className="search-icon">🔍</span>
            </button>
            {isSearching && (
              <button className="clear-button" onClick={clearSearch}>
                ✕
              </button>
            )}
          </div>
          
        </div>
        <div className="hero-pattern">
          <div className="pattern-circle"></div>
          <div className="pattern-circle"></div>
          <div className="pattern-circle"></div>
        </div>
      </header>
      <OurServices />

      <main className="main-content">
        {isSearching && searchResults.length === 0 ? (
          <div className="no-results">
            <h3>No templates found</h3>
            <p>Try different search terms or browse all categories</p>
            <button className="browse-all-button" onClick={clearSearch}>
              Browse All Templates
            </button>
          </div>
        ) : (
          searchResults.map((section) => (
            <section key={section.section} className="category-section">
              <div className="section-header">
                <div className="header-accent">
                  <div className="section-icon-placeholder">
                    {section.section.charAt(0)}
                  </div>
                </div>
                <h2 className="section-title">{section.section}</h2>
              </div>
              
              <div className="tools-grid">
                {section.items.map((app) => (
                  <Link
                    key={app.name}
                    href={app.href}
                    className="tool-card"
                  >
                    {app.badge && <div className="card-badge">{app.badge}</div>}
                    <div className="card-content">
                      <div className="icon-wrapper">
                        <div className="tool-icon-placeholder">
                          {app.name.charAt(0)}
                        </div>
                      </div>
                      <div className="text-content">
                        <h3 className="tool-title">{app.name}</h3>
                        <p className="tool-description">{app.desc}</p>
                      </div>
                      <div className="hover-indicator">
                        <span className="arrow-icon">→</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div> 
            </section> 
          ))
        )} 
      </main> 
    </div> 
  ); 
}